<template>
<div class="fc-page mg-page mg-shop_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>校区管理</h1><p>维护校区资料，设置账户模式与教学提醒</p></div><div class="mg-heading-actions"></div></header><section class="fc-filters" aria-label="校区管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getShopList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="校区编号" outlined v-model="query.shopNo" color="#d9363e" aria-label="校区编号"></v-text-field></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="校区名称" outlined v-model="query.shopName" color="#d9363e" aria-label="校区名称"></v-text-field></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="校区列表"><div class="fc-list-heading"><h3>校区列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

				<template v-slot:item.status="{item}">
					<v-chip small :color="shopStatusColor(item.status)">{{ shopStatusName(item.status) }}</v-chip>
				</template>
				<template v-slot:item.shopLogo="{item}">
					<v-avatar circle class="my-1">
						<v-img v-if="item.shopLogo" :src="imgPrev + item.shopLogo" width="50" height="50"></v-img>
					</v-avatar>
				</template>

				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>
					<v-btn @click.stop="showShopConfig(item)" color="#d9363e" class="ml-3" small depressed>系统设置</v-btn>
				</template>
			</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="修改校区" v-model="update.dialog" max-width="600" scrollable>
			<v-card class="fc-dialog-card mg-dialog">
				<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>修改校区信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改校区" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

				<v-card-text class="fc-dialog-body">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="校区名称" v-model="update.shop.shopName" dense outlined color="#d9363e" aria-label="校区名称"></v-text-field>
						</v-col>
						<v-col cols="12">
							<!-- 上传图片组件 -->
							<!-- <uploadPhoto :show="update.dialog" title="校区LOGO" :previewImg="update.shop.shopLogo" @success="uploadSuccess"></uploadPhoto> -->
							<cutImageUpload :show="update.dialog" title="校区LOGO" :previewImg="update.shop.shopLogo"  @success="uploadSuccess"></cutImageUpload>
						</v-col>

						<v-col cols="12">
							<!-- 上传图片组件 -->
							<!-- <uploadPhoto :show="update.dialog" title="校区LOGO" :previewImg="update.shop.shopLogo" @success="uploadSuccess"></uploadPhoto> -->
							<cutImageUpload :show="update.dialog" title="招生微信二维码" :previewImg="update.shop.qrCode"  @success="uploadQrCodeSuccess"></cutImageUpload>
						</v-col>


						<v-col cols="12">
							<v-text-field label="校区地址" v-model="update.shop.address" dense outlined color="#d9363e" aria-label="校区地址"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="fc-dialog-actions">
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false" depressed>取消</v-btn>
					<v-btn @click="submitUpdateShop" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
<v-dialog title="校区配置" v-model="configDialog.show" max-width="600" scrollable>
			<v-card class="fc-dialog-card mg-dialog">
				<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>校区配置</span></h2><p>按校区实际运营方式配置账户、教学与通知</p></div><v-spacer/><v-btn icon aria-label="关闭校区配置" @click="configDialog.show=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

				<v-card-text class="fc-dialog-body">
					<v-row dense>
 <v-col cols="12">
  <div class="subtitle-2">账户类型（至少选择一种）</div>
  <div class="d-flex">
   <v-checkbox v-model="configDialog.configModel.accountModes" label="课时模式" value="1" class="mr-6" hide-details></v-checkbox>
   <v-checkbox v-model="configDialog.configModel.accountModes" label="金额模式" value="2" hide-details></v-checkbox>
  </div>
  <div class="caption grey--text mt-2">用于财务中心菜单和新增课程的扣费方式，已有课程和账户记录保留。</div>
 </v-col>
						<v-col cols="12" sm="6">
							<v-text-field label="课时低于多少时显示预警" type="number" v-model="configDialog.configModel.hoursWarnValue" dense outlined color="#d9363e" aria-label="课时低于多少时显示预警"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field label="学费金额低于多少时显示预警"  type="number" v-model="configDialog.configModel.cashWarnValue" dense outlined color="#d9363e" aria-label="学费金额低于多少时显示预警"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field label="班级少于多少节时预警"  type="number" v-model="configDialog.configModel.classTimesWarnValue" dense outlined color="#d9363e" aria-label="班级少于多少节时预警"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-checkbox v-model="configDialog.configModel.allowBook" label="开启约课功能" color="red" value="1" hide-details class="mt-1"></v-checkbox>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select v-model="configDialog.configModel.warnTomorrowRecordHour" :items="hoursItems" label="前一日几点提醒今日上课的课程"
								item-text="text" item-value="id" outlined dense color="#d9363e" aria-label="前一日几点提醒今日上课的课程"></v-select>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select v-model="configDialog.configModel.noticeReceiverIdList" :items="shopEmpList" label="系统通知接收人"
								item-text="trueName" item-value="id" multiple outlined dense color="#d9363e" aria-label="系统通知接收人"></v-select>
						</v-col>

						<v-col cols="12" sm="6">
							<v-checkbox v-model="configDialog.configModel.isNeedRate" label="开启课堂点评功能" color="red" value="1" hide-details class="mt-1"></v-checkbox>
						</v-col>
						<v-col cols="12" sm="6">
							<v-checkbox v-model="configDialog.configModel.isNeedPoint" label="开启积分功能" color="red" value="1" hide-details class="mt-1"></v-checkbox>
						</v-col>
						<v-col cols="12" sm="6" v-if="configDialog.configModel.isNeedRate == '1'" class="mt-3">
							<v-select v-model="configDialog.configModel.rateToType" :items="rateTypeList" label="点评方式"
								item-text="typeName" item-value="id" outlined dense color="#d9363e" aria-label="点评方式"></v-select>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="fc-dialog-actions">
					<v-spacer></v-spacer>
					<v-btn @click="configDialog.show=false" depressed>取消</v-btn>
					<v-btn @click="submitSetConfig" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog></div>
</template>

<script>

	import {EventBus} from '../../../config/eventBus'
	import global from '../../../config/global'
	import storage from "../../../config/storage"
	import cutImageUpload from "../../../components/cut_image_upload.vue"
	import utils from "../../../config/utils.js"
	export default {
		name: "shop-list",
		components:{cutImageUpload},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [
					{text: '首页',disabled: false,href: "/"},
					{text: '系统管理',disabled: true},
					{text: '校区管理',disabled: true},
				],
				imgPrev : global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{text: '校区编号',value: 'shopNo',sortable: false},
						{text: '校区名称',value: 'shopName',sortable: false},
						{text: '校区Logo',value: 'shopLogo',sortable: false},
						{text: '校区地址',value: 'address',sortable: false},
						{text: '状态',value: 'status',sortable: false},
						{text: '到期时间',value: 'expireDate',sortable: false},
						{text: '创建时间',value: 'createAt',sortable: false},
						{text: '操作',align: 'center',value: 'action',sortable: false},
					],
					list: [],
				},
				query: {
					loading:false,
					page: 1,
					size: 20,
					shopName: "",
					shopNo:""
				},
				update: {
					dialog: false,
					shop: {
						shopId: "",
						shopName: "",
						address: "",
						shopLogo:"",
						qrCode:""
					}
				},
				configDialog:{
					show:false,
					configModel:{}
				},
				hoursItems:[
					{id:"10",text:"上午10点"},{id:"11",text:"上午11点"},{id:"12",text:"上午12点"},{id:"13",text:"下午1点"},{id:"14",text:"下午2点"},
					{id:"15",text:"下午3点"},{id:"16",text:"下午4点"},{id:"17",text:"下午5点"},{id:"18",text:"下午6点"},{id:"19",text:"晚上7点"},
					{id:"20",text:"晚上8点"}
				],
				shopEmpList:[],
				rateTypeList:[
					{id:"1",typeName:"对每个学员单独点评"},
					{id:"2",typeName:"对班级统一点评"}
				]
			}
		},
		created() {
			this.getShopList();
			this.getShopEmployeeList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getShopList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getShopList();
			},
			showShopConfig(item){
				// 获取校区配置对象，显示dialog
				const that = this;
				let url = `/sys/shop/config/${item.id}?v=1`;
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						
						that.configDialog.configModel = response.data["data"] ? response.data["data"] : {};
 if (!Array.isArray(that.configDialog.configModel.accountModes)) that.$set(that.configDialog.configModel,"accountModes",["1","2"]);
						that.configDialog.show = true;
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			submitSetConfig(){
				// 提交修改
				console.log(this.configDialog.configModel);
				const that = this;
				let url = `/sys/shop/config/update`;
				
				let postData = this.configDialog.configModel;
 if (!postData.accountModes || !postData.accountModes.length) { this.$noty.error("请至少选择一种账户类型"); return; }
				
				if (!postData.isNeedRate){
					postData.isNeedRate = "0";
				}
				if (!postData.isNeedPoint){
					postData.isNeedPoint = "0";
				}
				if (!postData.allowBook){
					postData.allowBook = "0";
				}
				
				this.axios.post(url,postData).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.$noty.success("操作成功");
						that.configDialog.show = false;
 EventBus.$emit("accountModesUpdated");
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getShopList() {
				const that = this;
				this.query.loading = true;
				let url = `/sys/shop/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if (this.query.shopName) {
					url += "&shopName=" + this.query.shopName;
				}
				if (this.query.shopNo) {
					url += "&shopNo=" + this.query.shopNo;
				}


				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						
						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			shopStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}else if (state === "2") {
					stName = "已到期";
				}
				return stName;
			},
			shopStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "error";
				}

				return color;
			},
			showUpdate(item) {
				this.update.dialog = true;
				this.update.shop.shopId = item.id;
				this.update.shop.shopName = item.shopName;
				this.update.shop.address = item.address;
				
				this.update.shop.shopLogo = item.shopLogo;
				this.update.shop.qrCode = item.qrCode;
				
			},
			uploadSuccess(e){
				this.update.shop.shopLogo = e.key;
			},
			uploadQrCodeSuccess(e){
				this.update.shop.qrCode = e.key;
			},
			submitUpdateShop() {
				
				if (!this.update.shop.shopName) {
					this.$noty.error('门店名称不能为空');
					return
				}
				
				// api
				const that = this;
				let url = `/sys/shop/update`;
				let postData = this.update.shop;
				//postData.shopLogo = this.upload.key;
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getShopList();
							that.update.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			getShopEmployeeList() {
				const shopId = utils.getCurrentShopId();
				
				const that = this;

				let url = `/sys/shop/all/employee/list/${shopId}?v=1`;
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.shopEmpList = response.data["data"]? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
